import React from 'react';
import './StoryBubble.css';
import { useNavigate } from 'react-router-dom';
import addIcon from '../assets/addstory-icon.png';

/**
 * Props:
 * - user: { username, profilePic, isOnline, latestStory?, hasStory?, suggested? }
 * - isCurrentUser: boolean
 * - isSuggested: boolean (faded + no ring + no online dot)
 * - hasActiveStory: boolean (unseen story for this viewer → ring only)
 * - hasDbStory: boolean (raw story exists in DB within 24h → navigation)
 * - seen: boolean (viewer has fully seen all stories)
 * - onClick: optional override click handler (Home provides this)
 */
function StoryBubble({
  user,
  isCurrentUser,
  isSuggested = false,
  hasActiveStory = false,
  hasDbStory = null,
  seen = false,
  onClick,
}) {
  const navigate = useNavigate();

  // ✅ DB truth: story exists in the 24h window (ignore seen-state)
  const dbHasStory =
    !isSuggested &&
    (typeof hasDbStory === 'boolean'
      ? hasDbStory
      : (typeof user?.hasStory === 'boolean' ? user.hasStory : !!user?.latestStory));

  const isOnline = !!user?.isOnline;
  const avatarSrc = user?.profilePic || '/profile/placeholder-profile.png';

  const handleAvatarClick = () => {
    console.log('✅ [StoryBubble] AVATAR CLICK', {
      username: user?.username,
      isCurrentUser,
      isSuggested,
      dbHasStory,
      seen,
      hasActiveStory,
      hasOnClick: typeof onClick === 'function',
    });

    // If Home passed an onClick, let Home decide (drawer)
    if (typeof onClick === 'function') return onClick();

    // Suggested users: do nothing for now
    if (isSuggested) return;

    // Fallback routing if StoryBubble is used somewhere without onClick
if (isCurrentUser) {
  // ✅ No fallback navigation for self. Parent screen should decide (drawer).
  return;
}


    if (dbHasStory) navigate(`/stories/${user.username}`);
  };

  const handleAddClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    console.log('➕ [StoryBubble] PLUS ICON CLICK', {
      username: user?.username,
      isCurrentUser,
      dbHasStory,
      hasOnClick: typeof onClick === 'function',
    });

    // ✅ Do NOT navigate. We want the drawer choice.
    // Prefer Home's handler if provided (open drawer)
    if (typeof onClick === 'function') return onClick();

    // Fallback: if no parent handler exists
// ✅ No fallback navigation. Parent should decide (drawer).
return; 
 };

  const ringClass = isSuggested
    ? 'neutral'
    : (dbHasStory ? (seen ? 'seen' : (hasActiveStory ? 'active' : 'seen')) : 'neutral');

  return (
    <div
      className={`story-bubble-wrapper ${isSuggested ? 'is-suggested' : ''}`}
      onClick={handleAvatarClick}
    >
      <div className={`story-bubble ${ringClass}`}>
        <div className="story-ring">
          <div className={`story-inner ${ringClass === 'active' ? 'with-gap' : ''}`}>
            <img
              src={avatarSrc}
              alt={isCurrentUser ? 'Your profile' : `${user?.username}'s profile`}
              className="story-avatar-img"
              draggable="false"
            />
          </div>
        </div>

        {/* Online dot (hide for current user + suggested users) */}
        {!isCurrentUser && !isSuggested && isOnline && (
          <span className="online-dot" aria-label="Online" />
        )}

        {/* + overlay for current user ONLY */}
        {isCurrentUser && (
          <img
            src={addIcon}
            alt="Add story"
            className="add-story-overlay"
            onClick={handleAddClick}
            draggable="false"
          />
        )}
      </div>

      <span className="discovery-username">
        {isCurrentUser ? 'You' : user?.username}
      </span>
    </div>
  );
}

export default StoryBubble;
